import React from 'react';
import { useParams } from 'react-router-dom';
import SubSideBarNavigationLink from './SubSideBarNavigationLink';

const SubSidebar = ({ options }) => {
  const { client_id } = useParams(); // client_id is not used in the current code, but you can use it if needed

  

  return (
    <div className="sidebar d-none d-md-block " style={{ width: '250px' }}>
      <div className="h-100 d-flex flex-column">
        {/* Logo Section */}
        <div className=" logo d-flex align-items-center justify-content-start px-3" style={{height:"100px"}}>
          <div className="d-flex gap-2 align-items-center">
            <h5 className='m-0'>Settings</h5>
          </div>
        </div>

        {/* Navigation Links Section */}
        <div className="h-100 links overflow-y-auto">
          <ul className="px-0  d-flex flex-column gap-3">
            {options?.map((option) => (
              <SubSideBarNavigationLink key={option?.label} link={option} />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SubSidebar;
